import React from 'react';
import { NavLink } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeSelectUser, featureAllowed } from 'containers/App/selectors';
import configs from 'configs';
import routes from './routes';
import './styles.scss';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
  }

  routeIsVisible = route =>
    !route.hasOwnProperty('role') ||
      (Array.isArray(route.role) && route.role.some(roleNum => roleNum === parseInt(this.propsagentProfile.role || 0)))

  render() {
    const { match, agentProfile, featureAllowed } = this.props;
    let { role } = agentProfile;
    role = parseInt(role);
    const isGroupLeader = role === 1
    const onlyGroupLeaderSections = configs.onlyGroupLeaderSections || []

    return (
      <div
        className="menu-w color-scheme-dark
        color-style-bright menu-position-side
        menu-side-left menu-layout-mini
        sub-menu-style-over sub-menu-color-bright
        selected-menu-color-light menu-activated-on-hover
        menu-has-selected-link"
      >
        <ul className="main-menu">
          {routes.map((route, key) => {
            if (
              (
                (!route.hasOwnProperty('feature') && onlyGroupLeaderSections.indexOf(route.path) < 0)
                ||
                (!route.hasOwnProperty('feature') && onlyGroupLeaderSections.indexOf(route.path) >= 0 && isGroupLeader)
                ||
                (route.hasOwnProperty('feature') && featureAllowed(route.feature))
              ) &&
              (route.show && !route.hasOwnProperty('redirect') && parseInt(route.role) <= parseInt(role))
            ) {
              return (
                <li key={key}>
                  <NavLink
                    to={route.path}
                    aria-label={route.name}
                    activeClassName="menu-active"
                    isActive={() =>
                      route.path === match.path ||
                      (route.path !== '/' && match.path.startsWith(route.path))
                    }
                  >
                    <div className="icon-w">
                      <div className={route.icon} />
                      <div className="menu-description">{route.name}</div>
                    </div>
                  </NavLink>
                </li>
              );
            }

            return null
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
  agentProfile: makeSelectUser(),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(NavBar);
